import React from "react";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { Title } from "../../../../components";
import HomeCustomReportDocumentsTable from "./HomeCustomReportDocumentsTable";

const HomeDocumentsContent: React.FC = (): React.ReactElement => {
  const { tCommon } = useCustomTranslation();

  return (
    <div className="mb-2 sm:mb-4 sm:mt-4">
      <Title title={tCommon("home_documents")} />
      <p className="mb-4">{tCommon("home_documents_description")}</p>
      <HomeCustomReportDocumentsTable />
    </div>
  );
};

export default HomeDocumentsContent;
